var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 48096335"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#006D35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "business_center"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3772_4009",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 14,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 3,
    y: 3,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3772_4009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "business_center_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6665 6.49972V5.33305C7.6665 5.01222 7.78084 4.73747 8.0095 4.5088C8.23778 4.28052 8.51234 4.16638 8.83317 4.16638H11.1665C11.4873 4.16638 11.7621 4.28052 11.9908 4.5088C12.219 4.73747 12.3332 5.01222 12.3332 5.33305V6.49972H14.6665C14.9873 6.49972 15.2621 6.61405 15.4908 6.84272C15.719 7.07099 15.8332 7.34555 15.8332 7.66638V14.083C15.8332 14.4039 15.719 14.6786 15.4908 14.9073C15.2621 15.1356 14.9873 15.2497 14.6665 15.2497H5.33317C5.01234 15.2497 4.73778 15.1356 4.5095 14.9073C4.28084 14.6786 4.1665 14.4039 4.1665 14.083V7.66638C4.1665 7.34555 4.28084 7.07099 4.5095 6.84272C4.73778 6.61405 5.01234 6.49972 5.33317 6.49972H7.6665ZM8.83317 6.49972H11.1665V5.33305H8.83317V6.49972ZM14.6665 11.7497H11.7498V12.9164H8.24984V11.7497H5.33317V14.083H14.6665V11.7497ZM9.4165 11.7497H10.5832V10.583H9.4165V11.7497ZM5.33317 10.583H8.24984V9.41638H11.7498V10.583H14.6665V7.66638H5.33317V10.583Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkDone);
export default __webpack_public_path__ + "static/media/work_done.0128dd6837aab2761774bedb3f160b4a.svg";
export { ForwardRef as ReactComponent };